
window.onload = function () {
    if (!document.getElementById('measurementResultsModal')) {
        $(document.body).append(`
                <!-- Modal for displaying measurement results -->
                <div id="measurementResultsModal" class="modal lpo-template">
                    <div class="modal-content">
                        
                        <h2>Automatische Ermittlung von Körperdaten</h2>
                        <p>Hier finden Sie die Ergebnisse Ihrer Körpermaße. Wählen Sie „Messdaten verwenden“, um diese Messungen anzuwenden, oder wählen Sie „Neu starten“, um einen neuen Scan Ihrer Körpermaße zu starten.</p>
                        <!--<table id="measurementTable"> -->
                            <!-- Measurement results will be dynamically added here -->

                            <!-- </table>-->

                        <div id="measurementTable">
                            <div class="single-measurement-container bust-container">
                                Brustumfang : <span class="bust_girth"></span>
                            </div>
                            <div class="single-measurement-container waist-container">
                                Taillenumfang: <span class="waist_girth"></span>
                            </div>
                        </div>
                        
                        <button id="useThisDataBtn" class="btn">Messdaten verwenden</button> 
                        <!-- <button id="newScanBtn" class="btn">Starten Sie einen neuen Scan</button>-->
                        
                    </div>
                </div>
        `);
    }
     

    $(document).ready(function () {
        let result;
        var sizeez_measurements_keys_in_german = {
            'lowerarm_length': '_Unterarmlänge',
            'arm_length': '_Armlänge',
            'upperarm_length': '_Oberarmlänge',
            'across_back_shoulder_width': '_Über den Rücken schulterbreit',
            'torso_height': '_Rumpfhöhe',
            'shoulder_length': '_Schulterlänge',
            'height': '_Höhe',
            'inside_leg_height': '_Innenbeinhöhe',
            'neck_girth': '_Halsumfang',
            'upperarm_girth': '_Oberarmumfang',
            'wrist_girth': '_Handgelenkumfang',
            'elbow_girth': '_Ellenbogenumfang',
            'bust_girth': 'Brustumfang',
            'waist_girth': 'Taillenumfang',
            'hip_girth': '_Hüftumfang',
            'thigh_girth': '_Oberschenkelumfang',
            'calf_girth': '_Wadenumfang',
            'ankle_girth': '_Knöchelumfang',
            'scanId': '_Scan ID'
        };

        var sizeez_measurements_keys_in_german_for_modal_old = {
            'neck_girth': 'Halsumfang',
            'bust_girth': 'Brustumfang',
            'waist_girth': 'Taillenumfang',
            'hip_girth': 'Hüftumfang',
            'calf_girth': 'Wadenumfang',
            'ankle_girth': 'Knöchelumfang',
            'upperarm_girth': 'Oberarmumfang',
            'thigh_girth': 'Oberschenkelumfang',
            'wrist_girth': 'Handgelenkumfang'
        };
        var sizeez_measurements_keys_in_german_for_modal = {
            'waist_girth': 'Taillenumfang',
            'bust_girth': 'Brustumfang',
        };

        // var sizeez_measurements_keys_in_german = [
        //     {
        //         'lowerarm_length': '_Unterarmlänge',
        //         'arm_length': '_Armlänge',
        //         'upperarm_length': '_Oberarmlänge',
        //         'across_back_shoulder_width': '_Über den Rücken schulterbreit',
        //         'torso_height': '_Rumpfhöhe',
        //         'shoulder_length': '_Schulterlänge',
        //         'height': '_Höhe',
        //         'inside_leg_height': '_Innenbeinhöhe',
        //         'neck_girth': '_Halsumfang',
        //         'upperarm_girth': '_Oberarmumfang',
        //         'wrist_girth': '_Handgelenkumfang',
        //         'elbow_girth': '_Ellenbogenumfang',
        //         'bust_girth': '_Brustumfang',
        //         'waist_girth': '_Taillenumfang',
        //         'hip_girth': '_Hüftumfang',
        //         'thigh_girth': '_Oberschenkelumfang',
        //         'calf_girth': '_Wadenumfang',
        //         'ankle_girth': '_Knöchelumfang'
        //     }

        // ];

        var measurements_keys_display_name = [
            {
                category: "lengths",
                data: {
                    arms: {
                        lowerarm_length: '_Unterarmlänge',
                        arm_length: '_Armlänge',
                        upperarm_length: '_Oberarmlänge'
                    },
                    torso: {
                        across_back_shoulder_width: '_Über den Rücken schulterbreit',
                        torso_height: '_Rumpfhöhe',
                        shoulder_length: '_Schulterlänge'
                    },
                    height: '_Höhe',
                    legs: {
                        inside_leg_height: '_Innenbeinhöhe'
                    }
                }
            },
            {
                category: "girths",
                data: {
                    head: {
                        neck_girth: '_Halsumfang'
                    },
                    arms: {
                        upperarm_girth: '_Oberarmumfang',
                        wrist_girth: '_Handgelenkumfang',
                        elbow_girth: '_Ellenbogenumfang'
                    },
                    torso: {
                        bust_girth: '_Brustumfang',
                        waist_girth: '_Taillenumfang',
                        hip_girth: '_Hüftumfang'
                    },
                    legs: {
                        thigh_girth: '_Oberschenkelumfang',
                        calf_girth: '_Wadenumfang',
                        ankle_girth: '_Knöchelumfang'
                    }
                }
            }
        ];

        const form_id_container = $('form.product-single__form');
        var form_id = form_id_container.attr('id');


       



        // // Iterate over the measurements array
        // for (var i = 0; i < measurements_keys_display_name.length; i++) {
        //     var measurement = measurements_keys_display_name[i];

        //     // Check if the current object has a "category" key
        //     if (measurement.hasOwnProperty("category")) {
        //         console.log("Category:", measurement.category);

        //         // Iterate over the measurements in the current category
        //         for (var key in measurement.data) {
        //             if (measurement.data.hasOwnProperty(key)) {
        //                 console.log(key + ":", measurement.data[key]);
        //             }
        //         }
        //     }
        // }

        // $(document.body).append(`<div class="modal sizeez_measurements">
        //                             <div class="modal-overlay modal-toggle sizeez_measurements"></div>
        //                             <div class="modal-wrapper modal-transition sizeez_measurements">
        //                                 <div class="modal-header">
        //                                     <button class="modal-close modal-toggle"><svg class="icon-close icon sizeez_measurements" viewBox="0 0 32 32"><use xlink:href="#icon-close"></use></svg></button>
        //                                 </div>

        //                                 <div class="modal-body">
        //                                     <div class="modal-content">
        //                                         <div id="main-container" class="svelte-tal44v">
        //                                             <div id="upper-pane" class="svelte-tal44v">
        //                                                 <div class="svelte-tal44v" id="left-pane">
        //                                                     <div class="svelte-tal44v">
        //                                                         <h5 class="title instruction-title svelte-tal44v">Create New Scan</h5>
        //                                                         <div class="svelte-tal44v">Scan this QR Code to take your body measurements with sizeez App</div>
        //                                                     </div>
        //                                                     <div id="vrqr-qrcode-img" class="svelte-tal44v">
        //                                                             <img
        //                                                             src="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAPUAAAD1CAAAAACt2uy5AAADK0lEQVR42u3cy27UQBAFUP//T8MSCck997YdQrrOrALyTHwaqVyv4fo18XVRU1NTU1NTU1NTU1NTU1NTU1P36uvza/2OP3/310+3f7x97+0Nbd4pNTX1OPV9AFyqU/DtJeuL0/d++GRqaupp6jQ234bW3ZQx/Lz0Tqmpqan3M80q103j8PpeqKmpqffVt7cfBN6ggl5/HjU1NfUb9XVfPPf19fq67+gqUFNT/zB1MFH4T376xxMfamrqn6Pe7OkF9fBt8rjuPlY1fHLj1NTUM9RBjKzK4/Uko3pYPO4+UlNTT1IH5Wyw95YOQIKZRnC8674hNTX1dHVKTwcbAb2a2qYHTU1NPVPdg9NvRaQxvA/9FZ2amnq6uuoR9gV6NeJIy21qamrqa+drpumY4nmN/Lm/SE1NPV0dzBvSUL1ZoPdve2l+TU1NfZS6r4fTJDOdX1RPgvRiampq6najJMgbg0fE5pEnjUdqaupB6mqskG4Kpylt1aV8vatATU19irqaPFTrvWkZHfQSn9Tc1NTUk9Tr0Jruh/TZbHWA/cYfNTX1THUQWqsJbVoFpzE8PRNqauqZ6mqPrqpzN2e/aZ785jYONTX1Ueo0zwsuTknBTt/X1NfU1NTnqavSdV03V8OO6jmRJtDU1NSD1ZsrH5WhSm7TIjs+E2pq6mnqzfq6ehwEB93X9bvdQmpq6qPU65Qx3Q/uJ6/pYQWdwY2dYWpq6kPVj0N6OvtIc+L+n4Gamnq6epMU5JxV5hrMiL+wvqampj5KnY5Vq5XfqlsYNC1f7ypQU1Ofp65mtUHN3S/JpacdTEaoqampszWQoBiv+otpXps+LKipqaern5zJ5jcb1sJ0dYWamnq6Og6F9WAjzT7771F0+4DU1NQz1Gm0TP1pH7JfZ+lLa2pq6nHqNHnsi910G6Uf4sa/iJqaepq6GjD0kbZ6MFTPmEezD2pq6rnqaohRpbTpUDhNRqmpqamv8n+5rRqAQfiuNl6oqamp20luYK1GIcGMJBgoP9+yo6amPkWdboBUS3L9b0sHwF2/kpqaeob6+Bc1NTU1NTU1NTU1NTU1NTU1NfX69RthKZa0Z1+8PQAAAABJRU5ErkJggg=="
        //                                                             alt="qr code" class="svelte-tal44v"></div>
        //                                                 </div>
        //                                                 <div class="divider is-light is-vertical svelte-tal44v">OR</div>
        //                                                 <div class=" svelte-tal44v" id="right-pane">
        //                                                     <h5 class="title instruction-title svelte-tal44v">Reuse a Scan</h5> <span class="svelte-tal44v">You can
        //                                                         reuse a scan created earlier with sizeez App</span> <br class="svelte-tal44v"> <span
        //                                                         class="svelte-tal44v">Enter its 4-digit Scan ID here:</span>
        //                                                     <div id="scan-id-input-area" class="svelte-tal44v">
        //                                                         <div id="scan-id-input-form" class="svelte-tal44v">
        //                                                             <div class="wrapper  svelte-31to6w" style=""><input class="default-input  svelte-14544ht"
        //                                                                     style="border-radius:5px;font-family:&quot;Campton Book&quot;,&quot;PT Sans&quot;,Calibri,Tahoma,sans-serif;height:50px;box-shadow: 0 0 5px #ccc inset;border: solid 1px #ccc;font-size:1.4em;"
        //                                                                     placeholder="" maxlength="1"> <input class="default-input  svelte-14544ht"
        //                                                                     style="border-radius:5px;font-family:&quot;Campton Book&quot;,&quot;PT Sans&quot;,Calibri,Tahoma,sans-serif;height:50px;box-shadow: 0 0 5px #ccc inset;border: solid 1px #ccc;font-size:1.4em;"
        //                                                                     placeholder="" maxlength="1"> <input class="default-input  svelte-14544ht"
        //                                                                     style="border-radius:5px;font-family:&quot;Campton Book&quot;,&quot;PT Sans&quot;,Calibri,Tahoma,sans-serif;height:50px;box-shadow: 0 0 5px #ccc inset;border: solid 1px #ccc;font-size:1.4em;"
        //                                                                     placeholder="" maxlength="1"> <input class="default-input  svelte-14544ht"
        //                                                                     style="border-radius:5px;font-family:&quot;Campton Book&quot;,&quot;PT Sans&quot;,Calibri,Tahoma,sans-serif;height:50px;box-shadow: 0 0 5px #ccc inset;border: solid 1px #ccc;font-size:1.4em;"
        //                                                                     placeholder="" maxlength="1"> </div> <span id="scan-id-input-error"
        //                                                                 class="svelte-tal44v">*only letters (a-z) or numbers (0-9)</span> <button
        //                                                                 class="button is-primary right-pane-ok-button svelte-tal44v" disabled="">OK</button>
        //                                                         </div>
        //                                                     </div>
        //                                                 </div>
        //                                             </div>

        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                                 <div class="modal-footer">
        //                                     <div id="bottom-pane" class="svelte-tal44v"><span class="svelte-tal44v"><svg width="24" height="24"
        //                                                 xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" class="svelte-tal44v">
        //                                                 <path
        //                                                     d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm.5 17h-1v-9h1v9zm-.5-12c.466 0 .845.378.845.845 0 .466-.379.844-.845.844-.466 0-.845-.378-.845-.844 0-.467.379-.845.845-.845z"
        //                                                     style="fill: grey;" class="svelte-tal44v"></path>
        //                                             </svg></span>
        //                                         <div class="svelte-tal44v">Results will appear here once Scan is finished</div>
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                         </div>`
        // );



        // var test_result = "";
        // populateHiddenFilds(test_result);

        $("#mk-auto-scan-container").on('click', function (event) {
            event.preventDefault();

            $('.mk-auto-sizeez-container').addClass('checked');
            $('.mk-scan-type-scan-container').show();
            var setHiddenInput = `<input type="hidden" name="properties[_Sizzez_button]" value="AUTOMATISCHE ERMITTLUNG VON KÖRPERDATEN" form="${form_id}">`;
            $('#mk-append-data').append(setHiddenInput);
            startMeasurement();
        });
       
        $("#get-measurement-api-call").on('click', function (event) {
            event.preventDefault();
            hideError();
            $('.get-measurement-api-call-contanier').addClass('checked');
            $(".get-remeasurement-container").removeClass('checked');
            $('.second-step-container').show();
            $('.mk-qrcode-img-container').show();
            $('.reuse-code-container').hide();
            var hiddenInput = document.querySelector('input[name="properties[_Sizzez_Method]"]');

            if (hiddenInput && hiddenInput.value) {

                hiddenInput.value = "ERSTELLEN SIE EINEN NEUEN SCAN";
            } else {
                var setHiddenInput = `<input type="hidden" name="properties[_Sizzez_Method]" value="ERSTELLEN SIE EINEN NEUEN SCAN" form="${form_id}">`;
                $('#mk-append-data').append(setHiddenInput);
            }

            // $('.modal').toggleClass('is-visible');
            // fetchModalContent();
            // $(".mk-qrcode-img-container img").attr("src","data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAPUAAAD1CAAAAACt2uy5AAADK0lEQVR42u3cy27UQBAFUP//T8MSCck997YdQrrOrALyTHwaqVyv4fo18XVRU1NTU1NTU1NTU1NTU1NTU1P36uvza/2OP3/310+3f7x97+0Nbd4pNTX1OPV9AFyqU/DtJeuL0/d++GRqaupp6jQ234bW3ZQx/Lz0Tqmpqan3M80q103j8PpeqKmpqffVt7cfBN6ggl5/HjU1NfUb9XVfPPf19fq67+gqUFNT/zB1MFH4T376xxMfamrqn6Pe7OkF9fBt8rjuPlY1fHLj1NTUM9RBjKzK4/Uko3pYPO4+UlNTT1IH5Wyw95YOQIKZRnC8674hNTX1dHVKTwcbAb2a2qYHTU1NPVPdg9NvRaQxvA/9FZ2amnq6uuoR9gV6NeJIy21qamrqa+drpumY4nmN/Lm/SE1NPV0dzBvSUL1ZoPdve2l+TU1NfZS6r4fTJDOdX1RPgvRiampq6najJMgbg0fE5pEnjUdqaupB6mqskG4Kpylt1aV8vatATU19irqaPFTrvWkZHfQSn9Tc1NTUk9Tr0Jruh/TZbHWA/cYfNTX1THUQWqsJbVoFpzE8PRNqauqZ6mqPrqpzN2e/aZ785jYONTX1Ueo0zwsuTknBTt/X1NfU1NTnqavSdV03V8OO6jmRJtDU1NSD1ZsrH5WhSm7TIjs+E2pq6mnqzfq6ehwEB93X9bvdQmpq6qPU65Qx3Q/uJ6/pYQWdwY2dYWpq6kPVj0N6OvtIc+L+n4Gamnq6epMU5JxV5hrMiL+wvqampj5KnY5Vq5XfqlsYNC1f7ypQU1Ofp65mtUHN3S/JpacdTEaoqampszWQoBiv+otpXps+LKipqaern5zJ5jcb1sJ0dYWamnq6Og6F9WAjzT7771F0+4DU1NQz1Gm0TP1pH7JfZ+lLa2pq6nHqNHnsi910G6Uf4sa/iJqaepq6GjD0kbZ6MFTPmEezD2pq6rnqaohRpbTpUDhNRqmpqamv8n+5rRqAQfiuNl6oqamp20luYK1GIcGMJBgoP9+yo6amPkWdboBUS3L9b0sHwF2/kpqaeob6+Bc1NTU1NTU1NTU1NTU1NTU1NfX69RthKZa0Z1+8PQAAAABJRU5ErkJggg==");
            startMeasurement();
        });

        //  $("#mk-auto-scan-container").on('click', function (event) {
        //     event.preventDefault();
        //     hideError();
        //     $('.get-measurement-api-call-contanier').addClass('checked');
        //     $(".get-remeasurement-container").removeClass('checked');
        //     $('.second-step-container').show();
        //     $('.mk-qrcode-img-container').show();
        //     $('.reuse-code-container').hide();
        //     var hiddenInput = document.querySelector('input[name="properties[_Sizzez_Method]"]');

        //     if (hiddenInput && hiddenInput.value) {

        //         hiddenInput.value = "ERSTELLEN SIE EINEN NEUEN SCAN";
        //     } else {
        //         var setHiddenInput = `<input type="hidden" name="properties[_Sizzez_Method]" value="ERSTELLEN SIE EINEN NEUEN SCAN" form="${form_id}">`;
        //         $('#mk-append-data').append(setHiddenInput);
        //     }

        //     // $('.modal').toggleClass('is-visible');
        //     // fetchModalContent();
        //     // $(".mk-qrcode-img-container img").attr("src","data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAPUAAAD1CAAAAACt2uy5AAADK0lEQVR42u3cy27UQBAFUP//T8MSCck997YdQrrOrALyTHwaqVyv4fo18XVRU1NTU1NTU1NTU1NTU1NTU1P36uvza/2OP3/310+3f7x97+0Nbd4pNTX1OPV9AFyqU/DtJeuL0/d++GRqaupp6jQ234bW3ZQx/Lz0Tqmpqan3M80q103j8PpeqKmpqffVt7cfBN6ggl5/HjU1NfUb9XVfPPf19fq67+gqUFNT/zB1MFH4T376xxMfamrqn6Pe7OkF9fBt8rjuPlY1fHLj1NTUM9RBjKzK4/Uko3pYPO4+UlNTT1IH5Wyw95YOQIKZRnC8674hNTX1dHVKTwcbAb2a2qYHTU1NPVPdg9NvRaQxvA/9FZ2amnq6uuoR9gV6NeJIy21qamrqa+drpumY4nmN/Lm/SE1NPV0dzBvSUL1ZoPdve2l+TU1NfZS6r4fTJDOdX1RPgvRiampq6najJMgbg0fE5pEnjUdqaupB6mqskG4Kpylt1aV8vatATU19irqaPFTrvWkZHfQSn9Tc1NTUk9Tr0Jruh/TZbHWA/cYfNTX1THUQWqsJbVoFpzE8PRNqauqZ6mqPrqpzN2e/aZ785jYONTX1Ueo0zwsuTknBTt/X1NfU1NTnqavSdV03V8OO6jmRJtDU1NSD1ZsrH5WhSm7TIjs+E2pq6mnqzfq6ehwEB93X9bvdQmpq6qPU65Qx3Q/uJ6/pYQWdwY2dYWpq6kPVj0N6OvtIc+L+n4Gamnq6epMU5JxV5hrMiL+wvqampj5KnY5Vq5XfqlsYNC1f7ypQU1Ofp65mtUHN3S/JpacdTEaoqampszWQoBiv+otpXps+LKipqaern5zJ5jcb1sJ0dYWamnq6Og6F9WAjzT7771F0+4DU1NQz1Gm0TP1pH7JfZ+lLa2pq6nHqNHnsi910G6Uf4sa/iJqaepq6GjD0kbZ6MFTPmEezD2pq6rnqaohRpbTpUDhNRqmpqamv8n+5rRqAQfiuNl6oqamp20luYK1GIcGMJBgoP9+yo6amPkWdboBUS3L9b0sHwF2/kpqaeob6+Bc1NTU1NTU1NTU1NTU1NTU1NfX69RthKZa0Z1+8PQAAAABJRU5ErkJggg==");
        //     startMeasurement();
        // });

        $("#get-remeasurement").on('click', function (event) {
            event.preventDefault();
            hideError();
            $('.get-remeasurement-container').addClass('checked');
            $(".get-measurement-api-call-contanier").removeClass('checked');
            $('.second-step-container').show();
            $('.reuse-code-container').show();
            $('.mk-qrcode-img-container').hide();

            $('#reuse-first').val("");
            $('#reuse-two').val("");
            $('#reuse-three').val("");
            $('#reuse-four').val("");
            var hiddenInput = document.querySelector('input[name="properties[_Sizzez_Method]"]');

            if (hiddenInput && hiddenInput.value) {

                hiddenInput.value = "EINEN SCAN WIEDERVERWENDEN";
            } else {
                // Bhavik
                const form = document.querySelector('form.product-single__form');

                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'properties[_Sizzez_Method]';
                hiddenInput.value = 'EINEN SCAN WIEDERVERWENDEN';

                form.appendChild(hiddenInput);

                // var setHiddenInput = `<input type="hidden" name="properties[_Sizzez_Method]" value="EINEN SCAN WIEDERVERWENDEN" form="${form_id}">`;
                // $('#mk-append-data').append(setHiddenInput);
                
                // Bhavik
            }


            // $('.modal').toggleClass('is-visible');
            // fetchModalContent();
            // $(".mk-qrcode-img-container img").attr("src","data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAPUAAAD1CAAAAACt2uy5AAADK0lEQVR42u3cy27UQBAFUP//T8MSCck997YdQrrOrALyTHwaqVyv4fo18XVRU1NTU1NTU1NTU1NTU1NTU1P36uvza/2OP3/310+3f7x97+0Nbd4pNTX1OPV9AFyqU/DtJeuL0/d++GRqaupp6jQ234bW3ZQx/Lz0Tqmpqan3M80q103j8PpeqKmpqffVt7cfBN6ggl5/HjU1NfUb9XVfPPf19fq67+gqUFNT/zB1MFH4T376xxMfamrqn6Pe7OkF9fBt8rjuPlY1fHLj1NTUM9RBjKzK4/Uko3pYPO4+UlNTT1IH5Wyw95YOQIKZRnC8674hNTX1dHVKTwcbAb2a2qYHTU1NPVPdg9NvRaQxvA/9FZ2amnq6uuoR9gV6NeJIy21qamrqa+drpumY4nmN/Lm/SE1NPV0dzBvSUL1ZoPdve2l+TU1NfZS6r4fTJDOdX1RPgvRiampq6najJMgbg0fE5pEnjUdqaupB6mqskG4Kpylt1aV8vatATU19irqaPFTrvWkZHfQSn9Tc1NTUk9Tr0Jruh/TZbHWA/cYfNTX1THUQWqsJbVoFpzE8PRNqauqZ6mqPrqpzN2e/aZ785jYONTX1Ueo0zwsuTknBTt/X1NfU1NTnqavSdV03V8OO6jmRJtDU1NSD1ZsrH5WhSm7TIjs+E2pq6mnqzfq6ehwEB93X9bvdQmpq6qPU65Qx3Q/uJ6/pYQWdwY2dYWpq6kPVj0N6OvtIc+L+n4Gamnq6epMU5JxV5hrMiL+wvqampj5KnY5Vq5XfqlsYNC1f7ypQU1Ofp65mtUHN3S/JpacdTEaoqampszWQoBiv+otpXps+LKipqaern5zJ5jcb1sJ0dYWamnq6Og6F9WAjzT7771F0+4DU1NQz1Gm0TP1pH7JfZ+lLa2pq6nHqNHnsi910G6Uf4sa/iJqaepq6GjD0kbZ6MFTPmEezD2pq6rnqaohRpbTpUDhNRqmpqamv8n+5rRqAQfiuNl6oqamp20luYK1GIcGMJBgoP9+yo6amPkWdboBUS3L9b0sHwF2/kpqaeob6+Bc1NTU1NTU1NTU1NTU1NTU1NfX69RthKZa0Z1+8PQAAAABJRU5ErkJggg==");

            reuseExistingHandler();
        });

        // Function to update modal content with a loader
        function showLoader() {
            hideError();
            $('#mk-loader').show();
            // $('#mk-qrcode-img-container').hide();
            // $('#reuse-code-container').hide();

        }
        // Function to update modal content with a loader
        function hideLoader() {
            $('#mk-loader').hide();
        }

        function showError(text) {
            $('#mk-error-msg').html('');
            $('#mk-error-msg').html(text);
            $('#mk-error-msg').show();
        }
        function hideError() {
            $('#mk-error-msg').hide();
            $('#mk-error-msg').html('');

        }
        // Function to update modal content with QR code image
        function showQrCodeImage(qrCodeImageUrl) {
            $('#mk-loader').hide();
            $('#mk-qrcode-img-container img').attr('src', `data:image/png;base64, ${qrCodeImageUrl}`);
            $('#mk-qrcode-img-container').show();
            $('#reuse-code-container').hide();
        }
        // Utility function to simulate a delay using Promises
        function delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        var baseURL = 'https://api.mobilescan.me/v2/proxy';

        var shopID = 'shop_20240109_102450_525e44b0-aed9-11ee-8227-afc6550a1e99';
        var origin = 'carft-devising.myshopify.com';
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-shop-id", shopID);
        myHeaders.append("origin", origin);

        var headers = {
            "x-shop-id": shopID,
            "origin": origin,
        }


        // Function to simulate the initialization of the measurement process
        function initializeMeasurement() {
            return new Promise((resolve, reject) => {
                // Simulate an AJAX call to initialize the measurement process
                $.ajax({
                    url: `${baseURL}/measurements/init`,
                    type: 'GET',
                    success: resolve,
                    error: reject,
                    headers: headers,
                    redirect: 'follow'

                });
            });
        }


// function initializeMeasurement() {
//     return new Promise((resolve, reject) => {
//         $.ajax({
//             url: `${baseURL}/measurements/init`,
//             type: 'POST', // or GET depending on API
//             headers: headers,
//             contentType: 'application/json',
//             data: JSON.stringify({}), // if required
//             success: resolve,
//             error: function(xhr, status, error) {
//                 console.error('AJAX error', {
//                     status: xhr.status,
//                     statusText: xhr.statusText,
//                     responseText: xhr.responseText,
//                     error: error,
//                     readyState: xhr.readyState
//                 });
//                 reject(xhr);
//             }
//         });
//     });
// }


        // Function to simulate checking the state of the measurement
        function checkMeasurementState(id) {
            return new Promise((resolve, reject) => {
                // Simulate an AJAX call to check the state of the measurement
                $.ajax({
                    url: `${baseURL}/measurements/${id}/state`,
                    type: 'GET',
                    success: resolve,
                    error: reject,
                    headers: headers,
                    redirect: 'follow'
                });
            });
        }

        // Function to simulate requesting the result by calling GET /measurements/{id}
        function getResult(id) {
            return $.ajax({
                url: `${baseURL}/measurements/${id}`,
                type: 'GET',
                dataType: 'json',
                headers: headers,
                redirect: 'follow'
            });
        }

        // Function to start the measurement process
        async function startMeasurement() {
            try {
                // Step 1: Initialize the measurement process
                showLoader(); // Display loader while waiting for initialization
                const initResponse = await initializeMeasurement();

                // console.log('Measurement initialized:', initResponse);

                // Update modal content with QR code image
                showQrCodeImage(initResponse.qrcode);
                $('#openAppButton').attr('href', "");
                $('#openAppButton').attr('href', initResponse.link);

                // Step 2: Periodically check the state until it becomes ready (state = 2)
                const measurementId = initResponse.id;
                while (true) {
                    const stateResponse = await checkMeasurementState(measurementId);
                    // console.log('Current state:', stateResponse.state);

                    if (stateResponse.state === 2) {
                        // hideLoader();
                        // console.log('Measurement is ready!');
                        // Request the result (GET /measurements/{id})
                        result = await getResult(measurementId);
                        // populateHiddenFilds(result);
                        showMeasurementResults(result);
                        // console.log('Measurement Result:', result);
                        break;
                    }

                    // Simulate a delay before the next state check (adjust as needed)
                    await delay(3000);
                }
            } catch (error) {
                console.error('Error during measurement:', error);
            }
        }

        // Function to handle the click event for reusing existing measurements
        function reuseExistingHandler() {
            // Generate a new measurement ID for reuse
            let newMeasurementId;

            showLoader(); // Display loader while waiting for initialization
            initializeMeasurement()
                .then(initResponse => {
                    // console.log('New Measurement initialized for reuse:', initResponse);
                    newMeasurementId = initResponse.id;

                    hideLoader();
                    // Show the input field for the scan ID and the "Use Code" button
                    $('#reuse-code-container').show();
                    // Attach a click event handler for the "Use Code" button
                    $('#get-remeasurement-api-call').click(function (event) {
                        event.preventDefault();
                        hideError();
                        showLoader();
                        // Check the current measurement state before attempting to use the scan ID
                        useScanIdHandler(newMeasurementId);
                    });
                })
                .catch(error => {
                    console.error('Error during new measurement initialization:', error);
                    // Handle the case where an error occurs during measurement initialization
                    // For example, hide the loader and display an error message to the user
                    hideLoader();
                    console.error('An error occurred during the new measurement initialization. Please try again.');
                });
        }

        // Function to handle the use of existing measurements by scan ID
        function useScanIdHandler(measurementId) {
            const scanIdOne = $('#reuse-first').val();
            const scanIdTwo = $('#reuse-two').val();
            const scanIdThree = $('#reuse-three').val();
            const scanIdFour = $('#reuse-four').val();
            if (scanIdOne && scanIdTwo && scanIdThree && scanIdFour) {

                // Make a connection between job id and existing measurements using scan id
                const scanId = scanIdOne + scanIdTwo + scanIdThree + scanIdFour;
                useScanId(scanId, measurementId)
                    .then(response => {
                        // console.log('Connection with existing measurements successful:', response);
                        checkMeasurementStateAndFetchResult(measurementId);
                    })
                    .catch(error => {
                        hideLoader();
                        showError('Die Messdetails für die vorhandene Scan-ID konnten nicht abgerufen werden. Bitte überprüfen Sie die Scan-ID und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support, um Hilfe zu erhalten.');
                        // Hide the error message after 3 seconds
                        setTimeout(function () {
                            hideError();
                        }, 3000);
                        console.error('Error connecting with existing measurements:', error);
                    });
            }
        }

        // Function to simulate making a connection with existing measurements using scan ID
        function useScanId(scanId, jobId) {

            return $.ajax({
                url: `${baseURL}/measurements/share`,
                type: 'POST',
                dataType: 'json',
                headers: headers,
                data: JSON.stringify({
                    oldId: scanId,
                    newJobId: jobId
                }),

                redirect: 'follow'
            });
        }

        // Function to check the measurement state and fetch the result
        async function checkMeasurementStateAndFetchResult(measurementId) {
            try {
                // Check the state of the measurement
                const stateResponse = await checkMeasurementState(measurementId);
                // console.log('Current state:', stateResponse.state);

                if (stateResponse.state === 2) {
                    // hideLoader();
                    // Measurement is ready, fetch the result
                    result = await getResult(measurementId);
                    // populateHiddenFilds(result);
                    showMeasurementResults(result);
                    $('#get-remeasurement-api-call').unbind();
                    // console.log('Measurement Result:', result);
                } else {
                    // Measurement is not yet ready, inform the user or take appropriate action
                    alert('The measurement is not yet ready. Please wait for the process to complete.');
                }
            } catch (error) {
                console.error('Error checking measurement state:', error);
                // Handle the case where an error occurs during measurement state check
                alert('An error occurred while checking the measurement state. Please try again.');
            }
        }

        function findValueByKey(key, data) {
            // Check if the key exists in the top-level object
            if (data.hasOwnProperty(key)) {
                return data[key];
            }

            // Iterate through the object properties
            for (var prop in data) {
                if (data.hasOwnProperty(prop) && typeof data[prop] === 'object') {
                    // Recursively search for the key in nested objects
                    var result = findValueByKey(key, data[prop]);

                    if (result !== null) {
                        return result;
                    }
                }
            }

            // If the key is not found, return null
            return null;
        }

        function populateHiddenFilds(result) {
            //Bhavik
            const form = document.querySelector('form.product-single__form');
            //Bhavik
            // Iterate over the object and fetch keys and values
            for (var key in sizeez_measurements_keys_in_german) {
                if (sizeez_measurements_keys_in_german.hasOwnProperty(key)) {
                    var displayValue = sizeez_measurements_keys_in_german[key];
                    var resultValue = "";
                    if (result) {
                        resultValue = findValueByKey(key, result);
                    }


                    // var setHiddenInput = ``;
                    // if (displayValue == '_Scan ID') {
                    //     setHiddenInput = `<input type="hidden" name="properties[${displayValue}]" value="${resultValue}" form="${form_id}">`;
                    // } else {
                    //     setHiddenInput = `<input type="hidden" name="properties[${displayValue}]" value="${resultValue} cm" form="${form_id}">`;
                    // }


                    // $('#mk-append-data').append(setHiddenInput);

                    // Bhavik
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `properties[${displayValue}]`;
                    input.value = (displayValue === '_Scan ID') ? resultValue : `${resultValue} cm`;

                    form.appendChild(input);
                    // Bhavik
                }
            }
        }

        // Function to show the measurement results in a modal
        function showMeasurementResults(result) {
            hideLoader();
            // Clear previous results
            // $('#measurementTable').empty();
            $('.waist_girth').text('');
            $('.bust_girth').text('');

            const table_header = `<thead>
                                    <tr>
                                    <th>Measurements</th>
                                    <th>Size</th>
                                    </tr>
                                </thead>`;
            // $('#measurementTable').append(table_header);
            for (var key in sizeez_measurements_keys_in_german_for_modal) {
                if (sizeez_measurements_keys_in_german_for_modal.hasOwnProperty(key)) {
                    // var displayValue = sizeez_measurements_keys_in_german_for_modal[key];
                    var resultValue = findValueByKey(key, result);

                    if ('waist_girth' == key) {
                        $('.waist_girth').text(`${resultValue} cm`);

                    } else if ('bust_girth' == key) {
                        $('.bust_girth').text(`${resultValue} cm`);
                    }
                    // Update the content of the spans with the values from the result

                    // const row = `<tr><td>${displayValue}</td><td>${resultValue}</td></tr>`;

                    // $('#measurementTable').append(row);

                }
            }

            // Show the modal
            $('#measurementResultsModal').modal();
        }

        // Click event for "Use This Data" button in the measurement results modal
        $('#useThisDataBtn').click(function () {
            populateHiddenFilds(result);
            hideLoader();


            $('.close-modal').click();
            $('.mk-scan-type-scan-container').hide();

            // to reset / reload for 2nd time click functionality issue in scan ID

          // event.preventDefault();
          //   hideError();
            // $('.get-remeasurement-container').addClass('checked');
            // $(".get-measurement-api-call-contanier").removeClass('checked');
            // $('.second-step-container').show();
            $('.reuse-code-container').show();
            // $('.mk-qrcode-img-container').hide();

            $('#reuse-first').val("");
            $('#reuse-two').val("");
            $('#reuse-three').val("");
            $('#reuse-four').val("");
            
            reuseExistingHandler();
        });

        // Click event for "New Scan" button in the measurement results modal
        // $('#newScanBtn').click(function () {

        //     // Close the modal
        //     $('.close-modal').click();
        //     hideLoader();
        //     $('.get-measurement-api-call-contanier').addClass('checked');
        //     $(".get-remeasurement-container").removeClass('checked');
        //     $('.second-step-container').show();

        //     // Perform the steps for creating a new scan
        //     startMeasurement();
        // });

        $('.reuse-digit').on('input', function (event) {
            moveToNextField(this, event);
        });

        $('.reuse-digit').on('keydown', function (event) {
            moveToPrevField(this, event);
        });

        function moveToPrevField(inputField, event) {
            var currentLength = $(inputField).val().length;

            // Handle backspace key
            if (event.which == 8) {
                if (currentLength === 0) {
                    // Move focus to the previous input field if available
                    var prevInputField = $(inputField).prev('.reuse-digit');
                    if (prevInputField.length > 0) {
                        prevInputField.focus();
                        return false; // Prevent the default behavior of the backspace key
                    }
                }
            }

            // Handle left arrow key
            if (event.which == 37) {
                // Move focus to the previous input field if available
                var prevInputField = $(inputField).prev('.reuse-digit');
                if (prevInputField.length > 0) {
                    prevInputField.focus();
                    return false; // Prevent the default behavior of the left arrow key
                }
            }

            // Handle right arrow key
            if (event.which == 39) {
                // Move focus to the next input field if available
                var nextInputField = $(inputField).next('.reuse-digit');
                if (nextInputField.length > 0) {
                    nextInputField.focus();
                    return false; // Prevent the default behavior of the right arrow key
                }
            }

        }
        function moveToNextField(inputField, event) {
            var maxLength = parseInt($(inputField).attr('maxlength'));
            var currentLength = $(inputField).val().length;

            if (currentLength === maxLength) {
                // Move focus to the next input field
                var nextInputField = $(inputField).next('.reuse-digit');
                if (nextInputField.length > 0) {
                    nextInputField.focus();
                }
            }

            // Check if all four fields have valid values
            const allFieldsValid = $('#reuse-first').val().length === 1 &&
                $('#reuse-two').val().length === 1 &&
                $('#reuse-three').val().length === 1 &&
                $('#reuse-four').val().length === 1;

            // Enable or disable the "Get Measurement" button based on validation
            $('#get-remeasurement-api-call').prop('disabled', !allFieldsValid);

        }

    }); // end of document ready



    /** 
     * when product is added to cart we have to empty the appended data for the sizeez data
     * we have to do it as below
     * re: https://community.shopify.com/c/shopify-apps/how-to-add-the-event-snippet-added-to-cart-event-from-klaviyo-on/m-p/1919791 
     */

    // function addedToCart() {
    //     fetch(`${window.location.origin}/cart.js`)
    //         .then(res => res.clone().json().then(data => {
    //             $("#mk-append-data input[type='hidden']").remove();
    //         }))
    // }
    // (function (ns, fetch) {
    //     ns.fetch = function () {
    //         const response = fetch.apply(this, arguments);
    //         response.then(res => {
    //             if (`${window.location.origin}/cart/add.js`
    //                 .includes(res.url)) {
    //                 addedToCart()
    //             }
    //         });
    //         return response
    //     }
    // }(window, window.fetch))
    // $(document).ajaxComplete(function (event, request, settings) {
    //     if (settings.url == "/cart/add.js") {
    //         addedToCart()
    //     }
    // })
}

document.getElementById('body-data-container').addEventListener('click', function () {
    document.querySelector('.body-data-container').classList.remove('active');
});

// Bhavik
const stepContainer = document.getElementById('second-step-container');
if (stepContainer) {
    stepContainer.addEventListener('click', function () {
      document.querySelector('.second-step-container').style.display = 'none';
    });
}

// document.getElementById('second-step-container').addEventListener('click', function () {
//     document.querySelector('.second-step-container').style.display = 'none';
// });
// Bhavik
document.getElementById('mk-scan-type-scan-container').addEventListener('click', function () {
    document.querySelector('.mk-scan-type-scan-container').style.display = 'none';
});